import React from "react";
import { FormattedMessage } from "react-intl";
function Ebrochure() {
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="dow-head">
            <div className="container" style={{ width: "100%" }}>
              <h3 style={{ textAlign: "center" }}><FormattedMessage id="e-brochure" /></h3>
              <img src={require('../../assets/img/shahara_brochure.jpg')} alt="" style={{ width: "inherit" }} className="img-brch w-100 mw-100" />
              <div className="col-md-12 col-sm-12 col-xs-12"
                style={{ display: "flex", justifyContent: "space-around", marginTop: "15px" }}>
                <a target="_blank" rel="noopener noreferrer" href="https://assets.windseworld.com/ebrochure/hi/" style={{ color: "black", fontSize: "22px" }} className="corp-link">Hindi</a>
                <a target="_blank" rel="noopener noreferrer" href="https://assets.windseworld.com/ebrochure/en/" style={{ color: "black", fontSize: "22px" }} className="corp-link">English </a>
              </div>
              <div className="text-center">Download Captain App Now</div><br />
              <div className="app-dow">
                <a href="https://play.google.com/store/apps/details?id=com.winds.karyakarta"
                  target="_blank" rel="noopener noreferrer"><img src={require('../../assets/img/android.png')} alt="" /></a>
                <a href="https://apps.apple.com/in/app/winds-captain/id1432613583"
                  target="_blank" rel="noopener noreferrer"><img src={require('../../assets/img/ios.png')} alt="" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Ebrochure;